import { useCallback } from 'react';
import { useSnackbar } from 'notistack';

import { deleteAdminLogisticZone } from '~services/admin/logisticsZones';

import { useLazyRequest } from './useLazyRequest';

export const useLogisticZoneAdminDelete = (
  onSuccessDelete?: () => void,
): {
  loading: boolean;
  handleDeleteLogisticZone: (zoneId: string) => Promise<void>;
} => {
  const { enqueueSnackbar } = useSnackbar();

  const [, loadingDeleteLogisitcZone, , executeDeleteLogisitcZone] =
    useLazyRequest({
      request: deleteAdminLogisticZone,
      withPostSuccess: (response) => {
        const logisitcZoneCode = response.data?.data.code;
        const message = `La zona logística ${logisitcZoneCode} fue eliminada correctamente`;

        enqueueSnackbar(message, { variant: 'success' });

        onSuccessDelete?.();
      },
      withPostFailure: () => {
        enqueueSnackbar(
          'No se pudo elimnar la zona logística, intente nuevamente',
          { variant: 'error' },
        );
      },
    });

  const handleDeleteLogisticZone = useCallback(
    async (zoneId: string) => {
      await executeDeleteLogisitcZone(zoneId);
    },
    [executeDeleteLogisitcZone],
  );

  return { loading: loadingDeleteLogisitcZone, handleDeleteLogisticZone };
};
